import { render, staticRenderFns } from "./ClassTable.vue?vue&type=template&id=756b8061&scoped=true&"
import script from "./ClassTable.vue?vue&type=script&lang=js&"
export * from "./ClassTable.vue?vue&type=script&lang=js&"
import style0 from "./ClassTable.vue?vue&type=style&index=0&id=756b8061&lang=less&scoped=true&"
import style1 from "./ClassTable.vue?vue&type=style&index=1&id=756b8061&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756b8061",
  null
  
)

export default component.exports